// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"a10a3f92e9--wrapper--bqhtA","title":"a10a3f92e9--title--jZq9o","actions":"a10a3f92e9--actions--zERZC","buttons":"a10a3f92e9--buttons--ErgtJ"};